
















































































import _ from 'lodash';
import { defineComponent, onMounted, watch, computed, ref, toRefs, getCurrentInstance } from '@vue/composition-api';
import MessageHandler from '@/renderer/views/message/compositions/messageHandler';

// 引入工具类
import tips, { MsgError } from '@/renderer/scripts/utils/tips';
import smh from '@/renderer/scripts/smh';
import { i18n_t } from '@/locales/i18n';
import MessageItem from './MessageItem.vue';
enum MessageType {
  all = 0,
  system = 1,
  warn = 2,
}
export default defineComponent({
  components: {
    MessageItem,
  },
  props: {
    list: {
      type: Array,
    },
    type: {
      type: String,
      required: true,
    },
  },
  setup(props, context) {
    const vm = getCurrentInstance()?.proxy || context.root;
    const {
      columns,
      methods: messageMethods,
      pageData,
      messageData,
      loading,
      selectMode,
      selectedRowKeys,
    } = MessageHandler();
    const store = context.root.$store;
    const messageNumber = computed(() => store.getters.messageNumber);
    const messageType: number = MessageType[props.type as keyof typeof MessageType];
    const confirmDlgVisible = ref(false);
    const displayColumns = ref(['detail']);
    const strReadAllBtn = ref(i18n_t('全部标记为已读'));
    const strDeleteBtn = ref(i18n_t('全部删除'));
    const strSelectModeBtn = ref(i18n_t('选择'));
    const deletePopupTitle = ref(i18n_t('你确定要清空全部消息吗？'));
    let firstEnter = true;
    const handleMessageNumChange = _.debounce(val => {
      if (val) {
        messageMethods.pullList(messageType);
      }
    }, 1000);
    const refreshMessageList = () => {
      messageMethods.pullList(messageType);
    };
    const checkAll = computed(() => {
      if (messageData.contents.length <= selectedRowKeys.value.length) {
        return true;
      }
      return false;
    });
    const checkAllIndeterminate = computed(() => {
      if (messageData.contents.length > selectedRowKeys.value.length && selectedRowKeys.value.length > 0) {
        return true;
      }
      return false;
    });
    const hasCheckItem = computed(() => {
      if (!selectMode.value || selectedRowKeys.value.length > 0) {
        return false;
      }
      return true;
    });

    messageMethods.pullList(messageType);
    const methods = {
      currPageChange() {
        messageMethods.pullList(messageType);
        store.commit('SET_MESSAGE_NUMBER', 0);
      },
      pageSizeChange() {
        messageMethods.pullList(messageType).then(() => {
          // 处理页码超出上限的情况，重置当前页码
          if (messageData.contents.length === 0 && pageData.currPage > 1) {
            pageData.currPage = 1;
            messageMethods.pullList(messageType);
          }
        });
        store.commit('SET_MESSAGE_NUMBER', 0);
      },
      confirmDelete() {
        confirmDlgVisible.value = false;
        methods.deleteMessage();
      },
      onDeleteMessageItem: () => {
        messageMethods.pullList(messageType).then(() => {
          if (messageData.contents.length === 0 && pageData.currPage > 1) {
            pageData.currPage -= 1;
            messageMethods.pullList(messageType);
          }
        });
      },
      async deleteMessage() {
        if (selectMode.value) {
          const deleteList: number[] = [];
          selectedRowKeys.value.forEach(item => {
            if (typeof item === 'number') {
              deleteList.push(item);
            }
          });
          await messageMethods.deleteItemList(messageType, deleteList);
          reporter.report('notification', {
            notification_empty: 'notification_empty',
          });
        } else {
          await messageMethods.deleteAll(messageType);
          reporter.report('notification', {
            notification_empty_all: 'notification_empty_all',
          });
        }
        this.onDeleteMessageItem();
      },
      toggleConfirmDlg: () => {
        confirmDlgVisible.value = !confirmDlgVisible.value;
      },
      onConfirmDlgVisibleChange: (visible: boolean) => {
        confirmDlgVisible.value = visible;
      },
      handleSelectAll: () => {
        if (checkAll.value) {
          selectedRowKeys.value = [];
        } else {
          selectedRowKeys.value = [];
          messageData.contents.forEach(item => {
            selectedRowKeys.value.push(item.id);
          });
        }
      },
    };
    watch(messageData, async val => {
      if (val && firstEnter) {
        store.commit('SET_MESSAGE_NUMBER', 0);
        firstEnter = false;
      }
      context.emit('updateTotalNum', messageData.allMessageNum);
      if (val?.unreadMessageNumber) {
        try {
          await smh.userAPI.readAllMessage({
            type: messageType,
          });
        } catch (e) {
          tips.error(e as MsgError);
        }
      }
    });
    watch(messageNumber, val => {
      // 非初次进入 && 在当前页面监测到有新消息时再进行处理
      if (val && !firstEnter && !selectMode.value) {
        handleMessageNumChange(val);
      }
    });
    watch(selectMode, val => {
      if (val) {
        strReadAllBtn.value = i18n_t('标记为已读');
        strDeleteBtn.value = i18n_t('清空');
        strSelectModeBtn.value = i18n_t('取消');
        deletePopupTitle.value = i18n_t('你确定要清空选中消息吗？');
      } else {
        strReadAllBtn.value = i18n_t('全部标记为已读');
        strDeleteBtn.value = i18n_t('全部删除');
        strSelectModeBtn.value = i18n_t('选择');
        deletePopupTitle.value = i18n_t('你确定要清空全部消息吗？');
      }
    });
    onMounted(async () => {
      store.commit('SET_MESSAGE_NUMBER', 0);
    });
    return {
      columns,
      messageType,
      pageData,
      messageMethods,
      messageData,
      loading,
      confirmDlgVisible,
      displayColumns,
      selectMode,
      strReadAllBtn,
      strDeleteBtn,
      strSelectModeBtn,
      selectedRowKeys,
      checkAll,
      checkAllIndeterminate,
      hasCheckItem,
      ...toRefs(messageData),
      ...methods,
      deletePopupTitle,
    };
  },
});
